import FormField from 'components/FormField';
import { FV } from './share';
import { Radio, Select } from 'antd';
import { useTranslate } from '@tolgee/react';
import { DisabledProps } from '../TaskForm/share';

export interface OrderStatusFieldProps {
  scenarioType?: Marketing.AllScenarioType;
}

function OrderStatusField({ disabled }: OrderStatusFieldProps & DisabledProps) {
  const { t } = useTranslate();

  const label = t('limit_order_status');

  return (
    <FormField<FV['limitRule']['limitOrderStatus']>
      required
      name="limitRule.limitOrderStatus"
      label={label}
      validate={(value) => {
        const { enable = false, orderStatus = [] } = value || {};

        if (enable && orderStatus.length === 0) {
          return t('department.请选择x', { x: label });
        }
      }}
    >
      {({ field: { value, onChange, onBlur } }) => {
        const { enable = false, orderStatus = [] } = value || {};

        const radios = (
          <Radio.Group
            disabled={disabled}
            value={enable ? '1' : '0'}
            onChange={({ target: { value } }) =>
              onChange({
                enable: value === '1',
                orderStatus,
              })
            }
            style={{ marginBottom: '8px' }}
          >
            <Radio value="0">{t('aide.不限定')}</Radio>
            <Radio value="1">{t('limit')}</Radio>
          </Radio.Group>
        );

        const select = enable && (
          <Select
            allowClear
            showArrow
            disabled={disabled}
            dropdownMatchSelectWidth={false}
            mode="multiple"
            placeholder={t('department.请选择x', { x: label })}
            value={orderStatus}
            onChange={(orderStatus) =>
              onChange({
                ...value,
                orderStatus,
              })
            }
            onBlur={onBlur}
            style={{ width: 'auto', minWidth: '360px', maxWidth: '720px' }}
            options={[
              { value: 'BEFORE_SALES', label: t('aide.售前') },
              { value: 'DURING_SALES', label: t('aide.售中') },
              { value: 'AFTER_SALES', label: t('aide.售后') },
            ]}
          />
        );

        return [<div className="mt-[4px]">{radios}</div>, <div>{select}</div>];
      }}
    </FormField>
  );
}

export default OrderStatusField;
